import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import "../styles/App.css";
import useCurrentProvider from "../hooks/useCurrentProvider";

const Navbar: React.FC = () => {
  const navigate = useNavigate();

  const { token, setToken } = useContext(AuthContext);

  const { isAdmin, isClinic, isProvider, isPatient, loading } =
    useCurrentProvider();

  const Logo = (
    <Link to="/" className="navbar-logo">
      <img
        src="/aliviapro_blue.png"
        alt="Alivia Pro."
        className="nav-bar-logo light-logo"
      />
    </Link>
  );
  const logout = () => {
    localStorage.clear();
    setToken(null);
    navigate("/");
  };

  if (loading) return null;
  if (isPatient) {
    return (
      <nav className="navbar">
        <div className="navbar-container">
          {Logo}
          <ul className="navbar-links">
            <li>
              <h3>are you one of our patients?</h3>
              <a
                href="https://aliviameds.com/"
                style={{ color: "lightblue", paddingLeft: "1rem" }}
              >
                click here to return to the patient site
              </a>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
  if (!token) {
    return (
      <nav className="navbar">
        <div className="navbar-container">
          {Logo}
          <ul className="navbar-links">
            <li>
              <Link to="/sign-in">Sign In</Link>
            </li>
            {/* <li>
              <Link to="/signup">Sign Up</Link>
            </li> */}
          </ul>
        </div>
      </nav>
    );
  }
  if (isAdmin) {
    return (
      <nav className="navbar">
        <div className="navbar-container">
          {Logo}
          <ul className="navbar-links">
            <li>
              <Link to="/admin/dashboard">Admin Dashboard</Link>
            </li>
            <li>
              <Link to="/clinics">Clinics</Link>
            </li>
            <li>
              <Link to="/questionnaires">Questionnaires</Link>
            </li>
            <li>
              <Link to="/providers">Providers</Link>
            </li>
            <li>
              <Link to="/patients">Patient List</Link>
            </li>
            <li>
              <button className="logout-button" onClick={logout}>
                Log Out
              </button>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
  if (isClinic || isProvider) {
    return (
      <nav className="navbar">
        <div className="navbar-container">
          {Logo}
          <ul className="navbar-links">
            {isClinic && (
              <li>
                <Link to="/clinic-profile">Clinic Profile</Link>
              </li>
            )}
            {isProvider && (
              <li>
                <Link to="/provider-profile">Provider Profile</Link>
              </li>
            )}
            <li>
              <Link to="/patients">Patient List</Link>
            </li>
            {isClinic && (
              <li>
                <Link to="/invoices">Invoices</Link>
              </li>
            )}
            <li>
              <Link to="/prescriptions">Prescriptions</Link>
            </li>
            {isClinic && (
              <li>
                <Link to="/all-medications">Medications</Link>
              </li>
            )}
            <li>
              <button className="logout-button" onClick={logout}>
                Log Out
              </button>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
  return (
    <nav className="navbar">
      <div className="navbar-container">
        {Logo}
        <ul className="navbar-links">
          <li>
            <Link to="/patients">Patient List</Link>
          </li>
          <li>
            <button className="logout-button" onClick={logout}>
              Log Out
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
